import React from 'react';
import CustomizableDashboard from '../../../components/dashboard/CustomizableDashboard';
import { WIDGET_CATEGORIES } from '../../../components/dashboard/widgetRegistry';
import { useClient } from '../../../contexts/ClientContext';

// Force clear all old cached layouts BEFORE component renders
// This ensures CustomizableDashboard doesn't load stale layouts
const CURRENT_LAYOUT_VERSION = '3.3-simple-layout';
const VERSION_KEY = 'health-dashboard-layout-version-check';

if (localStorage.getItem(VERSION_KEY) !== CURRENT_LAYOUT_VERSION) {
  // Clear all old health dashboard keys
  localStorage.removeItem('health-dashboard-layout');
  localStorage.removeItem('hub-dashboard-layout');
  localStorage.removeItem('health-dashboard-layout-version');
  localStorage.removeItem('health-dashboard-layout-v2');
  localStorage.removeItem('health-dashboard-layout-v3');

  // Set new version marker
  localStorage.setItem(VERSION_KEY, CURRENT_LAYOUT_VERSION);
}

/**
 * Health Dashboard Page
 * Cross-client overview of project delivery, budgets, and support health
 * Accessible to AWS and Partner users only
 */
const HealthDashboardPage: React.FC = () => {
  useClient();

  return (
    <CustomizableDashboard
      title="Health Dashboard"
      description="Monitor project delivery, budgets, and support across all accessible clients"
      storageKey="health-dashboard-layout-v3"
      context="health"
      widgetCategory={WIDGET_CATEGORIES.HEALTH}
      useBackendPersistence={false}
      allowSetDefault={true}
    />
  );
};

export default HealthDashboardPage;
